export const HEADER_SUBMENU_ITEM_CLASS = 'header-navigation__child-link'
